module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_pepita_blanca_tostada.aeea5cdc.pdf";